var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRevvBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8929 10.1875H13.3929C13.0982 10.1875 12.8571 9.94492 12.8571 9.64844V9.28906C12.8571 8.99258 13.0982 8.75 13.3929 8.75H20.8929C21.1875 8.75 21.4286 8.99258 21.4286 9.28906V9.64844C21.4286 9.94492 21.1875 10.1875 20.8929 10.1875ZM21.4286 12.5234V12.1641C21.4286 11.8676 21.1875 11.625 20.8929 11.625H13.3929C13.0982 11.625 12.8571 11.8676 12.8571 12.1641V12.5234C12.8571 12.8199 13.0982 13.0625 13.3929 13.0625H20.8929C21.1875 13.0625 21.4286 12.8199 21.4286 12.5234ZM24.317 24.5625H24.4643C24.7589 24.5625 25 24.8051 25 25.1016V25.4609C25 25.7574 24.7589 26 24.4643 26H8.57143C6.59821 26 5 24.3918 5 22.4062V6.59375C5 4.6082 6.59821 3 8.57143 3H23.9286C24.5223 3 25 3.48066 25 4.07812V20.6094C25 21.0586 24.7232 21.4449 24.3348 21.6066C24.1741 22.3299 24.1384 23.6551 24.317 24.5625V24.5625ZM10.7143 20.25H23.5714V4.4375H10.7143V20.25ZM6.42857 20.9688C7.02679 20.5195 7.76786 20.25 8.57143 20.25H9.28571V4.4375H8.57143C7.38839 4.4375 6.42857 5.40332 6.42857 6.59375V20.9688ZM23.0491 24.5625C22.9107 23.6461 22.9196 22.532 23.0491 21.6875H8.57143C5.71429 21.6875 5.71429 24.5625 8.57143 24.5625H23.0491Z",
    fill: "#61A578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevvBook);
export default __webpack_public_path__ + "static/media/revv_book.eafaf5186d8529ef4f343230b5d9501e.svg";
export { ForwardRef as ReactComponent };